import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  FormGroup,
  Label,
} from "reactstrap";
import { Form, Field } from "react-final-form";

import AttributesService from "./fields.service";
import AuthService from "../../Authentication/auth.service";

import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../../components/Loaders/DnaLoader";
import "../../../assets/custom css/loadoverlay.scss";

import Alerts from "../../../components/Alerts/alerts";


const AddAttribute = () => {

  const { t, i18n } = useTranslation();



  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('language'));
  }, []);


  const validateFtn = (values) => {
    console.log("values:-", values)
    const errors = {};
    if (!values.reminder_days) {
      errors.reminder_days = "Reminder (Days) is Required.";
    }
    if (!values.before_after) {
      errors.before_after = "Before After Due Date is Required.";
    }
    if (!values.status) {
      errors.status = "Status is Required.";
    }


    return errors;
  };
  const onSubmit = (values) => {
    console.log("values", values)
    var payloadData = {
      functionName: "ADD_Reminders",
      reminder_days: values.reminder_days,
      before_after: values.before_after,
      status: values.status,

    }
    setLoading(true);
    console.log("Attribute payload:-", payloadData)
    AttributesService.ADD_Reminders(payloadData).then((response) => {
      setLoading(false);
      if (response.data.status) {
        navigate("/Finance-Settings")
        if (response.data.message !== '') {
          Alerts.swalSuccessAlert(response.data.message)
        }
        else {
          Alerts.swalSuccessAlert(t("Reminder Added Successfully."));
        }
      }
      else {
        if (response.data.message !== '') {
          if (response.data.message === "Unauthorized") {
            AuthService.logout();
            navigate("/login");
            window.location.reload();
          }
          else {
            Alerts.swalErrorAlert(response.data.message)
          }
        }
        else {
          Alerts.swalErrorAlert(t("Error: Can't add attribute at the moment. Please try again later."))
        }
      }
    },
      (error) => {
        setLoading(false);
        const resMessage = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        Alerts.swalErrorAlert(t("Network Operation failed."))
      });
  };
  function confirmBack() {
    let msg = t("Once Back, you will not be able to revert!")
    Alerts.swalConfirmGeneralAlert(msg).then(res => {
      console.log("Resp:-", res)
      if (res === true) {
        navigate(-1)
      }
    })
  };
  return (
    <>
      <div className="app-main__outer">
        <div className="app-main__inner">
          <div className="app-page-title">
            <div className="page-title-wrapper justify-content-left">
              <div className="page-title-heading fw-bold">
                <div className="page-title-icon">
                  <i className="pe-7s-plus icon-gradient bg-happy-green" />
                </div>
                <div>{t('Add Reminder')}
                  <div className="page-title-subheading">
                    {t('Fill the form below to add a new Reminder.')}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-center">
            <div className="col-md-6">
              <Card className="main-card mb-3">
                <CardBody>
                  <LoadingOverlay tag="div" active={loading}
                    styles={{ overlay: (base) => ({ ...base }) }}
                    spinner={<DNALoader />}>
                    <Form
                      onSubmit={onSubmit}
                      validate={validateFtn}
                      render={({ handleSubmit, values, submitting, validating, valid }) => (
                        <form onSubmit={handleSubmit}>
                          <Row>
                            <Col md="12" >
                              <Row className="align-items-center">
                                <Col md="12">
                                  <Label className="">{("Remind User (Days)")}</Label>
                                </Col>
                                <Col md="12">
                                  <FormGroup className=" align-items-left">
                                    <Field name="reminder_days">
                                      {({ input, meta }) => (
                                        <div>
                                          <Input
                                            {...input}
                                            type="number"
                                            placeholder={'Days for Reminding User about Invoice'}
                                            invalid={meta.error && meta.touched}
                                          />
                                          {meta.error && meta.touched && (
                                            <span className="text-danger">{meta.error}</span>
                                          )}
                                        </div>
                                      )}
                                    </Field>
                                  </FormGroup>
                                </Col>
                              </Row>
                            </Col>
                            <Col md="12" >
                              <Row className="align-items-center">
                                <Col md="12">
                                  <Label className="">{("Before/After Due Date")}</Label>
                                </Col>
                                <Col md="12">
                                  <FormGroup className=" align-items-left">
                                    <Field name="before_after">
                                      {({ input, meta }) => (
                                        <div>
                                          <Input
                                            {...input}
                                            placeholder={''}
                                            type="select"
                                            invalid={meta.error && meta.touched}
                                          >
                                            <option disabled={false} value="">--{t("Select Before/After Due Date")}--</option>
                                            <option key='Before' value='Before'>{t("Before")}</option>
                                            <option key='After' value='After'>{t("After")}</option>
                                          </Input>
                                          {meta.error && meta.touched && (
                                            <span className="text-danger">{meta.error}</span>
                                          )}
                                        </div>
                                      )}
                                    </Field>
                                  </FormGroup>
                                </Col>
                              </Row>
                            </Col>


                            <Col md="12" >
                              <Row className="align-items-center">
                                <Col md="12">
                                  <Label className="">{("Status")}</Label>
                                </Col>

                                <Col md="12">
                                  <FormGroup className=" align-items-left">
                                    <Field name="status">
                                      {({ input, meta }) => (
                                        <div>
                                          <Input
                                            {...input}
                                            placeholder={''}
                                            type="select"
                                            invalid={meta.error && meta.touched}
                                          >
                                            <option disabled={false} value="">--{t("Select Status")}--</option>
                                            <option key='Active' value='Active'>{t("Active")}</option>
                                            <option key='Inactive' value='Inactive'>{t("Inactive")}</option>
                                          </Input>
                                          {meta.error && meta.touched && (
                                            <span className="text-danger">{meta.error}</span>
                                          )}
                                        </div>
                                      )}
                                    </Field>
                                  </FormGroup>
                                </Col>
                              </Row>
                            </Col>
                          </Row>

                          <Row style={{ marginTop: "20px" }}>
                            <FormGroup>
                              <div className="text-center">
                                <Button type="submit" className="btn btn-secondary btn-lg btn-hover-shine me-3">
                                  Save
                                </Button>
                                <button type="button" onClick={() => {
                                  if (state?.check) {
                                    localStorage.setItem('tab5', state.check);
                                  } else {
                                    localStorage.setItem('tab5', "1");
                                  }

                                  confirmBack();
                                }} className="btn btn-outline-success btn-lg btn-hover-shine me-3">
                                  Cancel
                                </button>
                              </div>
                            </FormGroup>
                          </Row>
                        </form>
                      )}
                    />
                  </LoadingOverlay>
                </CardBody>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </>
  );


}
export default AddAttribute;









